import {useState} from 'react';
import {OrganizationSwitcher} from './OrganizationSwitcher';

// Loads the identity's memberships only on explicit request, so isolated routes (checkout return,
// court references, signature) keep issuing no query beyond their own authorized context.
export function RoleContextSwitch({activeOrganizationId}:{activeOrganizationId:string}){
  const [open,setOpen]=useState(false);
  const [single,setSingle]=useState(false);
  if(!open)return <button type="button" className="button-link" onClick={()=>setOpen(true)}>Switch role workspace</button>;
  if(single)return <p role="status" className="form-note">No other role workspace is authorized for this sign-in.</p>;
  return <OrganizationSwitcher variant="compact" activeOrganizationId={activeOrganizationId} onUnavailable={()=>setSingle(true)}/>;
}
